import Vue from "vue"
import VueRouter from "vue-router"
import Login from "@/views/Login.vue"
import Panel from "@/views/Panel.vue"
import Tree from "@/views/Tree.vue"
import Stats from "@/views/Stats.vue"
import Ranking from "@/views/Ranking.vue"
import Promotion from "@/views/Promotion.vue"
import Packages from "@/views/Packages.vue"
import Purchases from "@/views/Purchases.vue"
import ChildPackage from "@/views/ChildPackage.vue"
import Test from "@/views/Test.vue"
import Dashboard from "@/views/Dashboard.vue"
import UserPanel from "@/views/UserPanel.vue"
import Family from "@/views/Family.vue"
import Payment from "@/views/Payment.vue"
import ResetPassword from "@/views/ResetPassword.vue"
import Lockr from "lockr"
import PubSub from "pubsub-js"

const loginGuard = (to, from, next) => {
  let token = Lockr.get("cop_token")
  if (token) return next()
  window.location.href = "/conectar"
}

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/inicio",
  },
  {
    path: "/inicio",
    redirect: "/panel/stats",
  },
  {
    path: "/reset-password/:recover_token",
    name: "ResetPassword",
    props: true,
    component: ResetPassword,
  },
  {
    path: "/promo/:uuid",
    name: "Promotion",
    props: true,
    component: Promotion,
  },
  {
    path: "/panel",
    name: "Panel",
    beforeEnter: loginGuard,
    component: Panel,
    children: [
      {
        path: "inicio",
        name: "Dashboard",
        beforeEnter: loginGuard,
        component: Dashboard,
      },
      {
        path: "user-panel",
        name: "UserPanel",
        beforeEnter: loginGuard,
        component: UserPanel,
      },
      {
        path: "compras",
        name: "Purchases",
        beforeEnter: loginGuard,
        component: Purchases,
      },
      {
        path: "hacer-test",
        name: "Tree",
        beforeEnter: loginGuard,
        component: Tree,
      },
      {
        path: "stats",
        name: "Stats",
        beforeEnter: loginGuard,
        component: Stats,
      },
      {
        path: "ranking",
        name: "Ranking",
        beforeEnter: loginGuard,
        component: Ranking,
      },
      {
        path: "packages",
        name: "Packages",
        beforeEnter: loginGuard,
        component: Packages,
      },
      {
        path: "package/:family",
        name: "ChildPackage",
        props: true,
        beforeEnter: loginGuard,
        component: ChildPackage,
      },
      {
        path: "payment/:family",
        name: "Payment",
        props: true,
        beforeEnter: loginGuard,
        component: Payment,
      },
      {
        path: "hacer-test-familia/:family",
        name: "Family",
        props: true,
        beforeEnter: loginGuard,
        component: Family,
      },
      {
        path: "hacer-test/:uuid/:subfamilyParam",
        name: "Test",
        props: true,
        beforeEnter: loginGuard,
        component: Test,
      },
    ],
  },
  {
    path: "/conectar",
    name: "Login",
    component: Login,
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  PubSub.publish("event.route", null)
  return next()
})

export default router
